import React from 'react'
import { Link } from 'react-router-dom'

const NotifyHeader = ({ item, markAsRead }) => {
  return (
    <div>
      <li>
        <div className='media'>
          <Link to={`${process.env.PUBLIC_URL}/notification`}>
          </Link>
          <div className='media-body px-2'>
            <Link to={`${process.env.PUBLIC_URL}/notification/`}>
              <h5>{item.notification_message} </h5> <i className='fa fa-envelope' aria-hidden='true' />
            </Link>
            </div>
        </div>
      </li>
      
      <div className='close-circle mt-2 px-2'>
          {/* <a href={null} onClick={markAsRead}> */}
            {new Date(item.notification_date).toDateString()}
          {/* </a> */}
        </div>
    <hr/>  
    </div>
    
  )
}

export default NotifyHeader
